module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/FdIcOj/tc-custom/9781459206588.jpg?1725275627085",
      "alt": "This image is the cover for the book World's Most Eligible Texan, Texas Cattleman's Club"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("World's Most Eligible Texan, Texas Cattleman's Club\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Nothing could make world-weary Aaron Black’s blood race anymore. Until the magical night he danced with Pamela Miles. The debonair man-about- town and the shy schoolteacher shared a night of intense desire...only, she disappeared the next morning. Determined to find his ladylove, Aaron soon tracked Pamela down and discovered she carried his child. Could he convince the proud country girl that his marriage proposal came not from duty but from a love even bigger than Texas?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sara Orwig\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Sara Orwig lives in Oklahoma and has a deep love of Texas. With a master’s degree in English, Sara taught high school English, was Writer-in-Residence at the University of Central Oklahoma and was one of the first inductees into the Oklahoma Professional Writers Hall of Fame. Sara has written mainstream fiction, historical and contemporary romance. Books are beloved treasures that take Sara to magical worlds. She loves both reading and writing them.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0